import api from '@utils/api';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { UserInfoActionTypes } from './common.types';
import userInfoSlice from './userInfo.slice';
function* handleGetUserInfo(action) {
    const userInfo = yield call(api.getUserInfo);
    yield put(userInfoSlice.actions.updateUserInfo(userInfo));
}
function* watchFetchRequest() {
    yield takeEvery(UserInfoActionTypes.FETCH_USERINFO, handleGetUserInfo);
}
export default function* userInfoSaga() {
    yield all([fork(watchFetchRequest)]);
}
